<mat-card>
  <mat-card-title> {{title}}</mat-card-title>
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
  <mat-card-actions align="end">
    <ng-content select="[cardActions]"></ng-content>
  </mat-card-actions>
</mat-card>
